import { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "../components/Header";

const DashboardLayout = ({ children }) => {

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  
    return (
      <div className="flex h-screen bg-gray-100">
        <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div className="flex-1 flex flex-col overflow-hidden">
          <Header toggleSidebar={toggleSidebar} />
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-200">
            {children}
          </main>
        </div>
      </div>
    );
  };


  export default DashboardLayout